import { render, staticRenderFns } from "./ContentFeed.vue?vue&type=template&id=5b94024e&scoped=true&"
import script from "./ContentFeed.vue?vue&type=script&lang=js&"
export * from "./ContentFeed.vue?vue&type=script&lang=js&"
import style0 from "./ContentFeed.vue?vue&type=style&index=0&id=5b94024e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b94024e",
  null
  
)

export default component.exports